<template>
    <div>
        <div class="video-container" v-if="this.videoFullWidth">
            <div ref="ytPlayerEl"></div>
        </div>
        <div class="container">
            <div class="left">
                <div class="video-container" v-if="!this.videoFullWidth">
                    <div ref="ytPlayerEl"></div>
                </div>
                <div class="song-title">{{ song ? song.originalName[$i18n.locale.slice(0, 2)] ||
                    song.originalName.ja :
                    ''
                }}</div>
                <div class="description-container">
                    <div class="head">
                        <div class="releasedata">{{ $t('publishedAt') }}: {{ song ? new
                            Date(song.publishedAt).toLocaleDateString() : '' }}</div>
                        <div class="viewCount"><span class="pi pi-play"></span> {{ song ?
                            convertNumberToString(song.viewCount) : '' }}</div>
                        <div class="likeCount" v-if="song && song.likeCount > 0"><span class="pi pi-heart"></span> {{
                            song ?
                                convertNumberToString(song.likeCount) : '' }}</div>
                    </div>
                    <div class="description" ref="descriptionEl" :class="{ expanded: descriptionExpanded }"
                        :style="descriptionStyle">
                        <div
                            v-html="song ? song.descriptionHtml[$i18n.locale.slice(0, 2)] || song.descriptionHtml.ja : ''">
                        </div>
                    </div>
                    <button class="toggle-description" @click="descriptionExpanded = !descriptionExpanded">
                        {{ descriptionExpanded ? $t('showLess') : $t('showMore') }}
                    </button>
                </div>
                <div class="info-container">
                    <table v-if="song" class="info-table">
                        <tbody>
                            <tr>
                                <th><span class="pi pi-tag th-icon"></span>{{ $t('infoTitle') }}</th>
                                <td>{{ song.displayName[$i18n.locale.slice(0, 2)] || song.displayName.ja }}</td>
                            </tr>
                            <tr>
                                <th><span class="pi pi-star th-icon"></span>{{ $t('infoType') }}</th>
                                <td>{{ song.type === 'original' ? $t('originalSong') : $t('coverSong') }}</td>
                            </tr>
                            <tr v-if="song.release && song.release != ''">
                                <th><span class="pi pi-folder th-icon"></span>{{ $t('infoRelease') }}</th>
                                <td>
                                    <div class="tag-container">
                                        <div class="tag" v-for="release in resolvedReleases" :key="release.name"
                                            :style="{ backgroundColor: '#cabaff' }">
                                            <a :href="release.releaseLink" target="_blank" rel="noopener noreferrer">{{
                                                release.name }}</a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th><span class="pi pi-calendar th-icon"></span>{{ $t('infoReleaseDate') }}</th>
                                <td>{{ song.releaseAt || new Date(song.publishedAt).toLocaleDateString() }}
                                </td>
                            </tr>
                            <tr v-if="song.artist">
                                <th><span class="pi pi-user th-icon"></span>{{ $t('infoArtist') }}</th>
                                <td>{{ song.artist }}</td>
                            </tr>
                            <tr>
                                <th><span class="pi pi-microphone th-icon"></span>{{ $t('infoSingers') }}</th>
                                <td>
                                    <div class="tag-container">
                                        <div class="tag" v-for="singer in resolvedSingers" :key="singer.name"
                                            :style="{ backgroundColor: singer.color }">
                                            <a :href="singer.channelUrl" target="_blank" rel="noopener noreferrer">{{
                                                singer.name }}</a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="song.lyrics && song.lyrics.length">
                                <th><span class="pi pi-pencil th-icon"></span>{{ $t('infoLyrics') }}</th>
                                <td>{{ song.lyrics.join(', ') }}</td>
                            </tr>
                            <tr v-if="song.composition && song.composition.length">
                                <th><span class="pi pi-wave-pulse th-icon"></span>{{ $t('infoComposition') }}</th>
                                <td>{{ song.composition.join(', ') }}</td>
                            </tr>
                            <tr v-if="song.arrangement && song.arrangement.length">
                                <th><span class="pi pi-sliders-h th-icon"></span>{{ $t('infoArrangement') }}</th>
                                <td>{{ song.arrangement.join(', ') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="release-container" v-if="song && song.release && song.release != ''">
                    <div class="release-info" v-for="release in resolvedReleases" :key="release.name">
                        <a :href="release.releaseLink" target="_blank" rel="noopener noreferrer" class="link">
                            <img :src="release.artworkUrl" :alt="release.name" />
                        </a>
                        <div class="details">
                            <div class="name">{{ release.name }}</div>
                            <div class="date">{{ $t('infoReleaseDate') }}: {{ release.releaseDate }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right" :class="{ 'sticky': !this.videoFullWidth }">
                <div class="filter-row">
                    <div class="type-filter-wrapper" ref="typeFilterWrapper">
                        <button class="type-filter-btn" @click="typeFilterOpen = !typeFilterOpen">
                            <span class="type-filter-title">{{ typeFilterLabel.title }}</span>
                            <span class="type-filter-description" v-if="typeFilterLabel.description">{{
                                typeFilterLabel.description }}</span>
                            <span class="pi pi-chevron-down type-filter-arrow" :class="{ open: typeFilterOpen }"></span>
                        </button>
                        <transition name="dropdown">
                            <ul v-show="typeFilterOpen" class="type-filter-dropdown">
                                <li :class="{ active: filteredSongsType === 'all' }" @click="selectTypeFilter('all')">{{
                                    $t('filterAll') }}</li>
                                <template v-for="release in releases" :key="release.name">
                                    <li :class="{ active: filteredSongsType === release.name }"
                                        @click="selectTypeFilter(release.name)" v-if="release.isShow">
                                        <span class="type-filter-title">{{ release.name }}</span>
                                        <span class="type-filter-description" v-if="release.description">{{ release.description }}</span>
                                    </li>
                                </template>
                                <li :class="{ active: filteredSongsType === 'breakyourxxx' }"
                                    @click="selectTypeFilter('breakyourxxx')">
                                    <span class="type-filter-title">Break your XXX</span>
                                    <span class="type-filter-description">Tokoyami Towa 1st solo Live</span>
                                </li>
                                <li :class="{ active: filteredSongsType === 'shinier' }"
                                    @click="selectTypeFilter('shinier')">
                                    <span class="type-filter-title">SHINier</span>
                                    <span class="type-filter-description">Tokoyami Towa 2nd Live</span></li>
                                <li :class="{ active: filteredSongsType === 'original' }"
                                    @click="selectTypeFilter('original')">{{
                                        $t('originalAllSong') }}</li>
                                <li :class="{ active: filteredSongsType === 'original-with-mv' }"
                                    @click="selectTypeFilter('original-with-mv')">{{
                                        $t('originalWithMVSong') }}</li>
                                <li :class="{ active: filteredSongsType === 'cover' }"
                                    @click="selectTypeFilter('cover')">{{
                                        $t('coverSong') }}</li>
                            </ul>
                        </transition>
                    </div>
                    <button class="sort-order-btn" @click="sortOrder = sortOrder === 'asc' ? 'desc' : 'asc'"
                        :title="sortOrder === 'asc' ? $t('sortAsc') : $t('sortDesc')">
                        <span :class="sortOrder === 'asc' ? 'pi pi-sort-amount-up' : 'pi pi-sort-amount-down'"></span>
                    </button>
                </div>
                <div class="video-card-container" :class="{ 'inline-scroll': !this.videoFullWidth }">
                    <div v-for="(song, index) in filteredSongs" :key="song.youtubeId" class="list-card-wrapper"
                        :data-index="index">
                        <VideoListCard v-if="visibleListMap[index]" :song="song" :current="song.youtubeId === youtubeId"
                            :filterType="filteredSongsType" />
                        <div v-else class="list-card-placeholder"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import config from '../assets/data/songs.js'
import releases from '../assets/data/releases.js';
import setlists from '../assets/data/setlists.js';
import VideoListCard from '@/components/VideoListCard.vue';

export default {
    name: 'VideoView',
    data() {
        return {
            config: config,
            releases: releases.releases,
            youtubeId: "",
            song: null,
            descriptionExpanded: false,
            filteredSongsType: 'all',
            typeFilterOpen: false,
            sortOrder: 'asc',
            player: null,
            videoFullWidth: false,
            visibleListMap: {}
        }
    },
    computed: {
        embedUrl() {
            const localeMap = { ja_JP: 'ja', en_US: 'en', kr_KR: 'ko' };
            const hl = localeMap[this.$i18n.locale] || 'en';
            return `https://www.youtube.com/embed/${this.youtubeId}?hl=${hl}&autoplay=0`;
        },
        descriptionStyle() {
            if (this.descriptionExpanded && this.$refs.descriptionEl) {
                return { maxHeight: this.$refs.descriptionEl.scrollHeight + 'px' };
            }
            return {};
        },
        resolvedReleases() {
            if (!this.song || !this.song.release) return null;
            return this.song.release.map(name => {
                const release = this.releases.find(r => r.name === name);
                return release ? release : {};
            });
        },
        resolvedSingers() {
            if (!this.song || !this.song.singers) return [];
            const lang = this.$i18n.locale.slice(0, 2);
            return this.song.singers.map(id => {
                const singer = this.config.singers.find(s => s.id === id);
                if (singer) {
                    return { name: singer[lang] || singer.ja || id, color: singer.color || '', channelUrl: singer.channelUrl || '' };
                }
                return { name: id, color: '', channelUrl: '' };
            });
        },
        filteredSongs() {
            const type = this.filteredSongsType;
            const sortByOrder = (arr) => [...arr].sort((a, b) => (a.order ?? Infinity) - (b.order ?? Infinity));
            let result;
            if (type === 'all') result = [...this.config.songs];
            else if (type === 'original') result = this.config.songs.filter(s => s.type === 'original');
            else if (type === 'original-with-mv') result = this.config.songs.filter(s => s.type === 'original' && s.isAvailableMV);
            else if (type === 'cover') result = this.config.songs.filter(s => s.type === 'cover');
            else if (type === 'breakyourxxx') result = this.getPlaylistByName('breakyourxxx');
            else if (type === 'shinier') result = this.getPlaylistByName('shinier');
            else {
                let isMatched = false;
                for (const release of this.releases) {
                    if (release.name === type) {
                        result = sortByOrder(this.config.songs.filter(s => {
                            if (Array.isArray(s.release)) {
                                return s.release.includes(release.name);
                            }
                            return false;
                        }));
                        isMatched = true;
                        break;
                    }
                }
                if (!isMatched) {
                    result = this.config.songs.filter(s => s.release.includes(type));
                }
            }
            return this.sortOrder === 'desc' ? [...result].reverse() : result;
        },
        typeFilterLabel() {
            const map = {
                all: {
                    title: this.$t('filterAll'),
                    description: "",
                }
            };
            for (const release of this.releases) {
                map[release.name] = { title: release.name, description: release.description || "" };
            }
            map['breakyourxxx'] = { "title": "Break your XXX", description: "Tokoyami Towa 1st solo Live" };
            map['shinier'] = { "title": "SHINier", description: "Tokoyami Towa 2nd Live" };
            map['original'] = { title: this.$t('originalAllSong'), description: "" };
            map['original-with-mv'] = { title: this.$t('originalWithMVSong'), description: "" };
            map['cover'] = { title: this.$t('coverSong'), description: "" };
            return map[this.filteredSongsType] || this.$t('filterAll');
        },
    },
    components: {
        VideoListCard
    },
    mounted() {
        if (window.innerWidth < 960) {
            this.videoFullWidth = true;
        }
        window.scrollTo({ top: 0, behavior: 'instant' });
        this.loadSong(this.$route.query.s, this.$route.query.t);
        this.$nextTick(() => {
            this.initYTApi();
            this.initListObserver();
        });
        this._onKeydown = (e) => {
            if (e.key === 't') {
                const wasPlaying = this.player && this.player.getPlayerState &&
                    this.player.getPlayerState() === window.YT.PlayerState.PLAYING;
                const currentTime = wasPlaying && this.player.getCurrentTime
                    ? this.player.getCurrentTime()
                    : null;
                this.videoFullWidth = !this.videoFullWidth;
                this.$nextTick(() => {
                    this.createPlayer(wasPlaying, currentTime);
                });
            } else if (e.key === 'ArrowRight') {
                this.playNext();
            }
        };
        window.addEventListener('keydown', this._onKeydown);
        this._onClickOutside = (e) => {
            if (this.$refs.typeFilterWrapper && !this.$refs.typeFilterWrapper.contains(e.target)) {
                this.typeFilterOpen = false;
            }
        };
        document.addEventListener('click', this._onClickOutside);
    },
    beforeUnmount() {
        window.removeEventListener('keydown', this._onKeydown);
        document.removeEventListener('click', this._onClickOutside);
        if (window.onYouTubeIframeAPIReady === this._ytApiReadyHandler) {
            window.onYouTubeIframeAPIReady = null;
        }
        if (this.player) {
            this.player.destroy();
            this.player = null;
        }
        if (this._listObserver) this._listObserver.disconnect();
    },
    watch: {
        '$route.query'(newQuery, oldQuery) {
            if (newQuery.s !== oldQuery.s || newQuery.t !== oldQuery.t) {
                this.loadSong(newQuery.s, newQuery.t);
            }
            if (newQuery.s !== oldQuery.s) {
                if (window.innerWidth < 960) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            }
        },
        filteredSongs() {
            this.visibleListMap = {};
            this.$nextTick(() => this.initListObserver());
        },
    },
    methods: {
        loadSong(id, type) {
            this.filteredSongsType = type || 'all';
            // idが省略されたときはフィルタ後の先頭の曲にリダイレクト
            if (!id) {
                const first = this.filteredSongs[0];
                if (first) {
                    this.$router.replace({ query: { s: first.youtubeId, ...(type ? { t: type } : {}) } });
                } else {
                    this.$router.push('/');
                }
                return;
            }
            const videoChanged = id !== this.youtubeId;
            this.youtubeId = id;
            this.descriptionExpanded = false;
            this.song = this.config.songs.find(song => song.youtubeId === this.youtubeId) || null;
            if (!this.song) {
                this.$router.push('/');
                return;
            }
            if (videoChanged) {
                if (this.player && this.player.loadVideoById) {
                    this.player.loadVideoById(this.youtubeId);
                } else if (!this.player && window.YT && window.YT.Player) {
                    // YT API はロード済みだがプレイヤーがまだない場合（初期リダイレクト後など）
                    this.$nextTick(() => this.createPlayer());
                }
                // YT API 未ロードの場合は onYouTubeIframeAPIReady が後で createPlayer() を呼ぶ
            }
            document.title = this.song.originalName[this.$i18n.locale.slice(0, 2)] + " | " + config.siteTitle[this.$i18n.locale.slice(0, 2)];
        },
        initYTApi() {
            if (window.YT && window.YT.Player) {
                this.createPlayer();
                return;
            }
            this._ytApiReadyHandler = () => this.createPlayer();
            window.onYouTubeIframeAPIReady = this._ytApiReadyHandler;
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(tag);
        },
        createPlayer(autoplay = true, startSeconds = null) {
            if (!this.youtubeId) return;
            if (this.player) this.player.destroy();
            const localeMap = { ja_JP: 'ja', en_US: 'en', kr_KR: 'ko' };
            const hl = localeMap[this.$i18n.locale] || 'en';
            this.player = new window.YT.Player(this.$refs.ytPlayerEl, {
                videoId: this.youtubeId,
                width: '100%',
                height: '100%',
                playerVars: {
                    hl,
                    autoplay: autoplay ? 1 : 0,
                    cc_lang_pref: hl,
                    ...(startSeconds != null ? { start: Math.floor(startSeconds) } : {})
                },
                events: {
                    onReady: this.onPlayerReady,
                    onStateChange: (e) => {
                        if (e.data === window.YT.PlayerState.ENDED) {
                            this.playNext();
                        }
                    },
                    onError: (e) => {
                        if (e.data === 101 || e.data === 150) {
                            console.log('This video has been restricted from embedded playback.');
                        }
                    },
                },
            });
        },
        onPlayerReady() {
        },
        initListObserver() {
            if (this._listObserver) this._listObserver.disconnect();
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const index = parseInt(entry.target.dataset.index);
                            this.visibleListMap = { ...this.visibleListMap, [index]: true };
                            observer.unobserve(entry.target);
                        }
                    });
                },
                { rootMargin: '600px 0px 600px 0px' }
            );
            this._listObserver = observer;
            this.$el.querySelectorAll('.list-card-wrapper').forEach(el => observer.observe(el));
        },
        convertNumberToString(num) {
            if (num == null) return '';
            return Number(num).toLocaleString();
        },
        playNext() {
            const currentIndex = this.filteredSongs.findIndex(song => song.youtubeId === this.youtubeId);
            if (currentIndex >= 0 && currentIndex < this.filteredSongs.length - 1) {
                const nextSong = this.filteredSongs[currentIndex + 1];
                // type指定があるときは継承させる
                const type = this.filteredSongsType !== 'all' ? this.filteredSongsType : null;
                this.$router.push(`/view?s=${nextSong.youtubeId}${type ? `&t=${type}` : ''}`);
            }
        },
        selectTypeFilter(value) {
            this.filteredSongsType = value;
            this.typeFilterOpen = false;
            const t = value !== 'all' ? value : undefined;
            this.$router.replace({ query: { s: this.youtubeId, ...(t ? { t } : {}) } });
        },
        getPlaylistByName(name) {
            var songs = [];
            for (const songId of setlists[name] || []) {
                songs.push(this.config.songs.find(s => s.youtubeId === songId));
            }
            return songs;
        },
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: row;
    margin: 16px 12px;
    gap: 20px;
    align-items: flex-start;
}

.container .left {
    width: calc(100vw - min(600px, 35vw));
}

.container .right {
    width: 35vw;
    max-width: 600px;
}

.sticky {
    position: sticky;
    top: calc(56px + 16px);
}

.inline-scroll {
    height: calc(100vh - 56px - 32px - 32px - 16px);
    overflow-y: auto;
    scrollbar-width: none;
    padding-left: 8px;
    margin-left: -8px;
}

.inline-scroll::-webkit-scrollbar {
    display: none;
}

.video-container {
    width: 100%;
    height: 0;
    padding-bottom: calc(100% * 9 / 16);
    position: relative;
    background-color: black;
}

.video-container :deep(iframe) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.song-title {
    margin: 8px auto 8px 8px;
    font-size: 1.5rem;
    font-weight: 700;
}

.description-container {
    margin-top: 8px;
    padding: 8px 12px;
    background-color: var(--color-surface);
    border-radius: 4px;

}

.description-container .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
}

.description-container .head .releasedata {
    margin-right: auto;
    font-weight: 500;
    font-size: 1.0rem;
}

.description-container .head .viewCount,
.description-container .head .likeCount {
    margin-left: 0;
    font-weight: 500;
    margin: auto 8px;
}

.description {
    overflow: hidden;
    max-height: 6em;
    position: relative;
    transition: max-height 0.5s ease;
    word-wrap: break-word;
}

.description:not(.expanded)::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2.5em;
    background: linear-gradient(to bottom, transparent, var(--color-surface));
    pointer-events: none;
}

.description.expanded {
    max-height: none;
}

.description pre {
    font-family: inherit;
    white-space: pre-wrap;
    word-break: break-word;
    margin: 0;
}

.description :deep(a) {
    color: var(--color-text-highlight);
    text-decoration: none;
}

.toggle-description {
    padding: 4px 32px 0 0;
    background: none;
    border: none;
    cursor: pointer;
    color: var(--color-accent);
    font-size: 0.875rem;
}

.info-container {
    margin-top: 16px;
    padding: 8px 12px;
    background-color: var(--color-surface);
    border-radius: 4px;
}

.info-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.95rem;
}

.info-table th,
.info-table td {
    padding: 6px 10px;
    text-align: left;
    border-bottom: 1px solid var(--color-border, rgba(128, 128, 128, 0.2));
    vertical-align: top;
}

.info-table th {
    width: 30%;
    font-weight: 600;
    color: var(--color-text-secondary, #888);
    white-space: nowrap;
}

.th-icon {
    margin-right: 6px;
    font-size: 0.85rem;
    opacity: 0.75;
}

.info-table tr:last-child th,
.info-table tr:last-child td {
    border-bottom: none;
}

.tag-container {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.tag {
    display: inline-block;
    color: var(--color-on-secondary);
    padding: 0px 8px 2px 8px;
    border-radius: 4px;
    transition: opacity 0.15s;
}

.tag:hover {
    opacity: 0.85;
}

.tag a {
    color: inherit;
    text-decoration: none;
    display: block;
}

.release-container {
    margin-top: 16px;
    padding: 16px 12px;
    background-color: var(--color-surface);
    border-radius: 4px;
}

.release-container .release-info {
    display: flex;
    gap: 16px;
}

.release-container .release-info+.release-info {
    margin-top: 12px;
    border-top: 1px solid var(--color-highlight);
    padding-top: 12px;
}

.release-info img {
    width: 100px;
    height: 100px;
    object-fit: cover;
}

.release-info a {
    text-decoration: none;
    display: block;
    height: 100px;
}

.release-info .name {
    font-weight: 400;
    font-size: 1.1rem;
}

.release-info .date {
    margin-top: 4px;
    color: var(--color-text-secondary, #888);
    font-size: 0.9rem;
}

.filter-row {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 8px;
}

.filter-row .type-filter-wrapper {
    flex: 1;
    margin-bottom: 0;
}

.sort-order-btn {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    background-color: var(--color-surface);
    color: var(--color-text);
    border: none;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    transition: color 0.15s;
}

.sort-order-btn:hover {
    color: var(--color-accent);
}

.type-filter-wrapper {
    position: relative;
    width: 100%;
    margin-bottom: 8px;
}

.type-filter-btn {
    width: 100%;
    height: 40px;
    padding: 8px 20px 8px 12px;
    background-color: var(--color-surface);
    color: var(--color-text);
    /* border: 1px solid var(--color-border, rgba(128, 128, 128, 0.3)); */
    border: none;
    border-radius: 4px;
    font-size: 0.9rem;
    cursor: pointer;
    outline: none;
    display: flex;
    align-items: center;
    text-align: left;
    transition: border-color 0.2s;
}

.type-filter-btn:hover {
    border-color: var(--color-accent);
}

.type-filter-title {
    margin-right: 4px;
}

.type-filter-description::before {
    content: ' - ';
}

.type-filter-description {
    font-size: 0.8rem;
    color: var(--color-text-secondary);
}

.type-filter-btn span:last-child {
    margin: auto 0 auto auto;
}

.type-filter-arrow {
    font-size: 0.75rem;
    opacity: 0.7;
    transition: transform 0.25s ease;
}

.type-filter-arrow.open {
    transform: rotate(180deg);
}

.type-filter-dropdown {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 100;
    list-style: none;
    margin: 0;
    padding: 4px 0;
    background-color: var(--color-surface);
    border: 1px solid var(--color-border, rgba(128, 128, 128, 0.3));
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}

.type-filter-dropdown li {
    padding: 8px 12px;
    cursor: pointer;
    font-size: 0.9rem;
    transition: background-color 0.15s, color 0.15s;
}

.type-filter-dropdown li:hover {
    background-color: var(--color-highlight, rgba(128, 128, 128, 0.15));
}

.type-filter-dropdown li.active {
    color: var(--color-accent);
    font-weight: 600;
}

/* dropdown open/close animation */
.dropdown-enter-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.dropdown-leave-active {
    transition: opacity 0.15s ease, transform 0.15s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
    opacity: 0;
    transform: translateY(-6px);
}

.video-card-container {
    /* border-radius: 4px; */
}

.list-card-wrapper {
    width: 100%;
}

.list-card-placeholder {
    width: 100%;
    height: 75px;
    background-color: var(--color-surface);
}

@media (max-width: 960px) {
    .container {
        margin: 16px 12px;
        display: block;
    }

    .container .left {
        width: 100%;
    }

    .container .right {
        width: 100%;
        max-width: none;
        margin-top: 16px;
    }

    .release-container {
        margin-top: 16px;
        padding: 8px 12px;
    }

    .release-container .release-info+.release-info {
        margin-top: 8px;
        padding-top: 8px;
    }

    .release-info a {
        height: 60px;
    }

    .release-info img {
        width: 60px;
        height: 60px;
    }

    .release-info .title {
        font-size: 1rem;
    }

    .release-info .date {
        font-size: 0.8rem;
    }
}
</style>